import React, { Component } from "react";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";

// Antd components
import { Input, Button } from "antd";

const { TextArea } = Input;

class OGOSettings extends Component {
  state = {
    username: this.props.delivery.ogo.username || "",
    password: this.props.delivery.ogo.password || "",
  };

  render() {
    const { t, config, settings, delivery } = this.props;
    if (!delivery || !delivery.ogo) return <></>;
    const titlesClassName = "mb-2 mt-3 ".concat(
      config.direction == "ltr" ? "text-left ml-1" : "text-right mr-1"
    );
    const divStyle = { paddingRight: 12, paddingLeft: 12, marginBottom: 10 };

    return (
      <div
        style={{
          direction: config.direction,
          textAlign: config.direction == "ltr" ? "left" : "right",
        }}
      >
        <p
          className={titlesClassName}
          style={{ fontWeight: "bold", color: "#333" }}
        >
          {t("OGO settings")}
        </p>
        <div
          className="whiteSubContainer"
          style={{
            marginBottom: 17,
            direction: config.direction,
          }}
        >
          <div style={divStyle}>
            <p className="mb-1 mt-2">Username</p>
            <Input
              placeholder="Username"
              defaultValue={delivery.ogo.username}
              onChange={(e) => this.setState({ username: e.target.value })}
              style={{ direction: "ltr" }}
            />
          </div>

          <div style={divStyle}>
            <p className="mb-1 mt-2">Password</p>
            <Input.Password
              placeholder="Password"
              defaultValue={delivery.ogo.password}
              onChange={(e) => this.setState({ password: e.target.value })}
              style={{ direction: "ltr" }}
              autoComplete="new-password"
            />
          </div>

          <div
            className="text-center"
            style={{ marginBottom: 8, marginTop: 13 }}
          >
            <Button
              type="primary"
              loading={this.props.saveLoading}
              onClick={() => this.props.save("ogo", this.state)}
            >
              {t("Save")}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    config: state.config,
    settings: state.auth.settings,
    delivery: state.integration.delivery,
  };
};

export default connect(mapStateToProps)(withNamespaces()(OGOSettings));
